module.exports = __webpack_public_path__ + "static/integration/d2l/img/ally-icon-indicator-perfect.a287f7db4d0d8bc8338953b0b6ea805a.svg";